import axiosInstance from './axiosInstance'; 


const API_URL = 'https://idealonline.com.tr/service/idealonline/v1/';

//send OTP
export const sendOtp = async ( token) => {
  try {
    const response = await axiosInstance.get(`otp/send`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error sending OTP:', error);
    throw error;
  }
};

//verify OTP
export const verifyOtp = async (token, otp) => {
  try {
    const response = await axiosInstance.get(`otp/verify/${otp}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error verifying OTP:', error);
    throw error;
  }
};